var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1319,
    height: 638,
    viewBox: "0 0 1319 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.82 200.469C1301.98 384.261 1120.95 509.961 943.513 572.991C754.296 640.206 500.773 688.733 364.065 539.266C233.182 396.167 471.044 190.514 424.902 5.97513C356.327 -268.277 -159.513 -528.418 50.144 -716.209C260.918 -905 522.449 -453.185 776.048 -308.548C858.237 -261.672 938.958 -234.611 1007.56 -170.158C1131.58 -53.6322 1331.97 36.2025 1317.82 200.469Z",
    fill: "url(#paint0_linear_277_588)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_277_588",
    x1: 619,
    y1: 610,
    x2: 991,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.309489,
    stopColor: "#FF6A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6979"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.1cff5908d511141c1e5b28d17b7aea9d.svg";
export { ForwardRef as ReactComponent };